// Split-test variant B of the funnel landing page.
// Each variant is an independent copy so it can diverge freely; the survey,
// scoring, routing and GHL integration stay shared via <SurveyForm />.
import { useState } from "react";
import { InflowHeader } from "@/components/inflow/InflowHeader";
import { InflowFooter } from "@/components/inflow/InflowFooter";
import { VidalyticsEmbed } from "@/components/inflow/VidalyticsEmbed";
import { SurveyForm } from "@/components/Survey/SurveyForm";
import { useVariantSession } from "@/lib/use-variant-session";
import { logEvent } from "@/lib/analytics";

const LABEL = "B" as const;
const PATH = "/lp-b";

export default function VariantBPage({ track = true }: { track?: boolean }) {
  const [surveyOpen, setSurveyOpen] = useState(false);
  useVariantSession(LABEL, PATH, track);
  return (
    <div className="vsl-page min-h-screen bg-white font-sans text-black">
      <InflowHeader />

      <main className="mx-auto w-full max-w-3xl px-4 pb-20 text-center sm:px-5 sm:pb-14">
        <h1 className="text-balance leading-tight">
          <span className="block text-[15px] font-black text-black underline sm:text-xl">
            Clinic OWNERS that OFFER:
          </span>
          <span className="mt-1 block whitespace-nowrap text-[13px] font-black text-black sm:text-xl md:text-2xl">
            Decompression, Regen, Knee, Or Neuropathy Treatments
          </span>
          <strong className="mt-4 block text-xl font-black text-black sm:text-4xl md:text-5xl">
            Add <span className="text-[#5B2D9B]">20-30 Financially Qualified</span>{" "}
            Patients/mo Using The{" "}
            <span className="text-[#5B2D9B]">High Ticket Patient Program</span>
          </strong>
          <em className="mt-4 block text-[15px] font-black italic text-black sm:text-lg">
            Guaranteed, Or You Don't Pay
          </em>
        </h1>

        <section className="mt-8 sm:mt-12">
          <h2 className="text-base font-black text-[#5B2D9B] sm:text-xl">
            Step 1: Watch This Breakdown Video Below
          </h2>
          <div className="vsl-purple-glow mt-2 overflow-hidden rounded-xl border-[3px] border-[#5B2D9B] p-0.5 sm:mt-3 sm:rounded-2xl sm:border-4 sm:p-1">
            <VidalyticsEmbed />
          </div>
        </section>

        <section className="mt-8 sm:mt-14">
          <h2 className="text-base font-black text-[#5B2D9B] sm:text-xl">
            Step 2: Apply Below To Work With Us
          </h2>
          <div className="mt-3 sm:mt-4">
            <button
              type="button"
              onClick={() => {
                void logEvent("cta_click");
                setSurveyOpen(true);
              }}
              className="cta-purple-pulse w-full rounded-lg bg-[#5B2D9B] px-8 py-3.5 text-base font-black uppercase text-white transition-colors hover:opacity-90 sm:w-auto sm:py-4"
            >
              APPLY NOW
            </button>
          </div>
        </section>
      </main>



      <SurveyForm open={surveyOpen} onClose={() => setSurveyOpen(false)} />

      <InflowFooter />
    </div>
  );
}
